import React from "react";
import { FaLinkedin, FaInstagram, FaGithub } from "react-icons/fa";
import styled from "styled-components";

const Social = styled.div`
  display: block;
  position: fixed;
  top: 48%;
  left: 1.5rem;
  transform: translateY(-50%);

  ul {
    display: block;
  }

  .item + .item {
    margin-top: 1rem;
  }

  a {
    font-size: 2rem;
    color: rgb(119, 119, 121);
    transition: 0.2s ease-in;
    &:hover {
      color: rgb(57, 134, 250);
    }
  }

  svg {
    &:hover {
      transition: 0.2s ease-in;
      fill: rgb(57, 134, 250);
    }
  }

  @media screen and (max-width: 768px) {
    display: none;
  }
`;
function FixSocialIcon() {
  return (
    <Social>
      <ul>
        <li className="item">
          <a
            href="https://www.linkedin.com/in/abdulmajeed-alduaifi/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin />
          </a>
        </li>
        <li className="item">
          <a
            href="https://github.com/Majeed99"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaGithub />
          </a>
        </li>
        <li className="item">
          <a
            href="https://profile.satr.codes/user/MAJEEDx99"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              fill="rgb(119,119,121)"
              // xmlns="http://www.w3.org/2000/svg"
              width="70"
              height="25.068"
              viewBox="0 0 119.992 28.068"
            >
              <g transform="translate(-325.53 -349.63)">
                <path
                  class="a"
                  d="M554.516,361.434h-.048a5.647,5.647,0,0,1-5.647-5.647h0a5.647,5.647,0,0,1,5.647-5.647h.048a5.647,5.647,0,0,1,5.647,5.647h0A5.647,5.647,0,0,1,554.516,361.434Z"
                  transform="translate(-182.641 -0.32)"
                />
                <path
                  class="b"
                  d="M463.846,405.7H463.8a5.647,5.647,0,0,1-5.647-5.647h0a5.647,5.647,0,0,1,5.647-5.647h.048a5.647,5.647,0,0,1,5.647,5.647h0A5.647,5.647,0,0,1,463.846,405.7Z"
                  transform="translate(-125.79 -28.077)"
                />
                <rect
                  class="b"
                  width="28.75"
                  height="11.343"
                  rx="5.671"
                  transform="translate(332.356 349.664)"
                />
                <path
                  class="a"
                  d="M530.9,400.011h0a5.673,5.673,0,0,1-5.673,5.671h-17.4a5.672,5.672,0,0,1-5.673-5.671h0a5.672,5.672,0,0,1,5.673-5.671h17.4A5.672,5.672,0,0,1,530.9,400.011Z"
                  transform="translate(-153.378 -28.033)"
                />
              </g>
            </svg>
          </a>
        </li>
      </ul>
    </Social>
  );
}

export default FixSocialIcon;
